export const GlobalVariable = Object.freeze({
    BASE_API_URL: 'https://appapi.didbiz.com/',       
    BASE_URL: 'https://app.didbiz.com/#',       
    // d23at3rs98zo0i
});